import Post from "../../../components/post/post";
import doctor from '../../../assets/images/doctor.svg';
import css from './feed.scss';
import ivan from "../../../assets/images/avatars/ivan_avatar.jpg";
import olga from "../../../assets/images/avatars/olga_avatar.jpg";
import alex from "../../../assets/images/avatars/alex_avatar.jpg";
import svetlana from "../../../assets/images/avatars/svetlana_avatar.jpg";
import Frame from '../../../components/frames/frame';

const FeedPage = () => {
    return (
        <div className={css.root}>
            <main>
                <Post
                    id="1"
                    author="Иван"
                    date="17 сентября 2020"
                    authorAvatar={ivan}
                    content="Как выражается целиакия? В том-то и дело, что часто — никак. Она может долгое время протекать бессимптомно и впервые проявиться уже в преклонном возрасте. Болезнь могут спровоцировать беременность и роды у женщин, стрессовые ситуации, инфекции, лечение антибиотиками.
                        При этом организм воспринимает клейковину как патоген, то есть крайне нежелательного гостя. Иммунная система встречает его защитными иммунными комплексами.
                        Проблемы с желудочно-кишечным трактом
                        Стенки кишечника выстланы крошечными ворсинками. Они увеличивают площадь контакта с пищей и усиливают всасывание нутриентов.
                        Под действием иммунных комплексов кишечник воспаляется, его слизистая оболочка серьезно страдает. Ворсинки повреждаются, всасывание становится хуже. Итог — нарушение кишечных функций (диарея, вздутие живота).
                        "
                />
                <Post
                    id="2"
                    author="Ольга"
                    date="1 сентября 2020"
                    authorAvatar={olga}
                    content="Врачи-гинекологи выделяются два типа аменореи – ложную и истинную. В первом случае пациентки не сталкиваются с нарушением функций яичников. Препятствиями для кровотечения становятся врожденные анатомические дефекты: атрезия влагалища, шейки матки или девственной плевы. Менструальная кровь скапливается в маточных трубах, полости матки или влагалище.
                        Истинный тип обусловлен нарушением циклических процессов в организме женщины. Она возникает под действием физиологических или патологических причин. Физиологическая аменорея – естественное состояние, проявляющееся на фоне беременности, лактации или менопаузы. Патологическая аменорея – результат функциональных изменений в организме пациентки, не связанных с возрастными особенностями развития."
                />
                <Post
                    id="3"
                    author="Алексей"
                    date="7 мая 2020"
                    authorAvatar={alex}
                    content="Ранняя седина – процесс, когда у людей на голове появляются седые волосы. У людей, относящихся к монголоидной, европеоидной расе, это происходит до 25 лет. У негроидной расы это обычно происходит до 30 лет. Седину в раннем возрасте нельзя связывать со старением."
                />
                <Post
                    id="4"
                    author="Светлана"
                    date="8 апреля 2020"
                    authorAvatar={svetlana}
                    content="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veritatis, et esse libero similique laborum sed nemo ad iure architecto delectus repellat quam. Dolorum optio vel commodi eligendi eum ipsa iste!"
                />
                <Post
                    id="5"
                    author="Алла"
                    date="1 июня 2020"
                    content="Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ipsum laudantium optio sit iure obcaecati sed unde, doloremque at sapiente, voluptatibus qui vel. Eos iure assumenda ducimus temporibus, vitae aut!"
                />
            </main>
            <aside className={css.aside}>
                <Frame right white>
                    <section className={css.consultation}>
                        Предстоящие косультации
                    <div className={css.consultation__content}>
                            <img src={doctor} alt="doctor"/>
                            <div className={css.consultation__description}>
                                <div className="name">
                                    Винарская Виктория Леонидовна
                            </div>
                                <div className="specialization">
                                    Гинеколог
                            </div>
                            </div>
                        </div>
                    </section>
                </Frame>
            </aside>
        </div>
    );
}

export default FeedPage;